import { BrowserRouter } from 'react-router-dom';
import { MainRoutes } from './routes';
import React from 'react';

export function App() {
  return (
    <BrowserRouter>
      <MainRoutes />
    </BrowserRouter>
  );
}